import script from "./BalanceSheetColumnwise.vue?vue&type=script&setup=true&lang=js"
export * from "./BalanceSheetColumnwise.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__